import React from 'react';
import { useLocation } from 'react-router-dom';
import BottomNav from './BottomNav';
import { MessageCircle } from 'lucide-react';

export default function AppShell({ children }) {
  const { pathname } = useLocation();
  const hideFab = pathname.startsWith('/chat');
  return (
    <div className="min-h-screen bg-gray-50 flex justify-center">
      <div className="w-full max-w-md bg-white min-h-screen relative shadow-xl">
        <div className="pb-24">{children}</div>
        {!hideFab && (
        <a
          href="https://wa.me/917325893950"
          target="_blank"
          rel="noreferrer"
          data-testid="whatsapp-fab"
          className="fixed bottom-24 right-4 sm:right-[calc(50%-14rem)] w-12 h-12 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-lg z-30 transition-transform hover:scale-105"
          aria-label="WhatsApp"
        >
          <MessageCircle size={22} />
        </a>
        )}
        <BottomNav />
      </div>
    </div>
  );
}
